import { IonInput } from "@ionic/react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { type FieldApi } from "@tanstack/react-form";
import { getErrorText } from "@/components/atoms/form-ion/utils";
import { cn } from "@/lib/style/cva.config";

export type CustomFieldInputProps = {
  label: string;
  description?: string;
  required?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldApi<
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

export const CustomFieldInput = forwardRef<
  HTMLIonInputElement,
  React.ComponentProps<typeof IonInput> & CustomFieldInputProps
>(function CustomFieldInput({ label, description, required = false, field, ...props }, ref) {
  const { i18n } = useTranslation();

  return (
    <IonInput
      ref={ref}
      name={field.name}
      value={field.state.value}
      onIonChange={(event) => {
        const value =
          props.type === "number" ? Number(event.detail.value) : String(event.detail.value);
        field.handleChange(value);
      }}
      onIonBlur={field.handleBlur}
      readonly={field.state.meta.isValidating || field.form.state.isSubmitting}
      errorText={getErrorText({ language: i18n.language, errors: field.state.meta.errors })}
      {...props}
      labelPlacement={props.labelPlacement ?? "stacked"}
      label={label}
      helperText={description}
      className={cn(
        required && "ion-required",
        field.state.meta.isTouched && "ion-touched",
        !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
        props.className,
      )}
    />
  );
});
